import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Heading } from '../EditCustomer/Heading';
import { getAccountReviewByIdAPI } from '../../../utils/apiServices/accountReviewAPI';
import { popup } from '../../../utils';
import { CircleSpinner, Edit } from '../../../assets/svg';
import CreateAccountReviewModal from './CreateAccountReviewModal';
import { QUERY_KEYS, ROLES } from '../../../constants';
import { useQuery } from '@tanstack/react-query';

const AccountReviewPage = () => {
    const { state } = useLocation();
    const role = useSelector((s) => s.user?.role);
    const accountName = useSelector((s) => s.accountArray?.selectedAccountName) || state?.name;
    const [showModal, setShowModal] = useState(false);
    const [content, setContent] = useState('');
    const [arId, setArId] = useState(null);
    const [title, setTitle] = useState(state?.title || '');
    const contentRef = useRef(null);
    const titleRef = useRef(null);

    const { data, isFetching, isError, error, isFetched } = useQuery({
        queryKey: [QUERY_KEYS.ACCOUNT_REVIEW_BY_ID, state?.accountReviewId],
        queryFn: async () => await getAccountReviewByIdAPI({ id: state?.accountReviewId }),
        select: (data) => data.data,
        enabled: !!state?.accountReviewId,
    });

    useEffect(() => {
        if (data && isFetched) {
            setContent(data?.content);
            setTitle(data?.title);
            setArId(data?.id);
            contentRef.current = data?.content;
            titleRef.current = data?.title;
        }
    }, [data, isFetched]);
    if (isError) popup('error', error?.message);

    return (
        <div className='account-review-page-container'>
            <Heading
                accountName={accountName}
                heading={`Account Review`}
                showAddButton={role !== ROLES.USER}
                addButtonText={'Edit Account Review'}
                addButtonIcon={<Edit stroke='currentColor' />}
                handleAddClick={() => setShowModal(true)}
            />
            <div className='d-flex flex-column gap-2 position-relative'>
                <div className='d-flex justify-content-center w-100'>
                    <span className='ar-title'>{title}</span>
                </div>
                <div className='divider'></div>
                <div className='ar-content-container'>
                    <div dangerouslySetInnerHTML={{ __html: content }} />
                </div>
                <div className='divider'></div>
                {isFetching && <CircleSpinner absolute size={'3rem'} />}
            </div>
            {showModal && (
                <CreateAccountReviewModal
                    showModal={showModal}
                    setShowModal={setShowModal}
                    accountId={state?.accountId}
                    isEditMode={true}
                    content={content}
                    title={title}
                    id={arId}
                />
            )}
        </div>
    );
};

export default AccountReviewPage;
